import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { repositorioBitacora } from '../../data/repositories/RepositorioBitacora';
import { useTiempoReal } from './useTiempoReal';

/**
 * ¿Hay fallos de entrega que el usuario aún no ha mirado?
 *
 * Se marcan como vistos al entrar en la bitácora, no al pulsar un botón: si
 * abriste la pantalla, ya los viste.
 */
export function useNovedadesBitacora(): boolean {
  const clienteConsultas = useQueryClient();
  const ubicacion = useLocation();
  const enLaBitacora = ubicacion.pathname === '/bitacora';

  const novedades = useQuery({
    queryKey: ['bitacora', 'novedades'],
    queryFn: () => repositorioBitacora.hayNovedades(),
    // Sin reintentos: si la consulta falla, el punto simplemente no aparece.
    retry: false,
  });

  // El servidor avisa en cuanto se registra un fallo nuevo.
  useTiempoReal({ tabla: 'op_eventos_control', evento: 'INSERT' }, () => {
    void clienteConsultas.invalidateQueries({ queryKey: ['bitacora', 'novedades'] });
  });

  useEffect(() => {
    if (!enLaBitacora || !novedades.data) return;

    void repositorioBitacora.marcarComoVistos().then(() => {
      void clienteConsultas.invalidateQueries({ queryKey: ['bitacora', 'novedades'] });
    });
  }, [enLaBitacora, novedades.data, clienteConsultas]);

  return novedades.data === true && !enLaBitacora;
}
